import { Component, OnInit } from '@angular/core';
import { ServiceStock } from '../service-stock.service';

import { gsap } from "gsap";
import { duration } from 'moment';
gsap.config({
  force3D: true,
});

declare let $: any;

@Component({
  selector: 'app-splashlogo',
  templateUrl: './splashlogo.component.html',
  styleUrls: ['./splashlogo.component.scss']
})
export class SplashlogoComponent implements OnInit {

  logoAnimationDelay:any = 3000;

  constructor(private services: ServiceStock) { }

  ngOnInit() {
    $('.main-header').addClass('headers');
  }
  ngAfterViewInit(){
    
   let circleLeftX = $('.logofg div').offset().left;
   let svgLeftX = $('.logofg svg').offset().left;
   let translateX = (circleLeftX - svgLeftX) + "px";

    let logoBgAI = gsap.timeline({
      paused: true,
      ease: "power3.inOut",
      smoothChildTiming: false
    });
    logoBgAI.eventCallback("onComplete", () => {
      $('app-splashlogo').hide();
    });
    logoBgAI.fromTo('.logofg div',{css:{opacity:1, scale:1}},{css:{opacity:0, scale:.25}, immediateRender: false,duration: 0.5},0);
    logoBgAI.fromTo('app-splashlogo',{css:{opacity:1}},{css:{opacity:0}, immediateRender: false,duration: 0.5},0);
    
    let logoAI = gsap.timeline({
      paused: true,
      ease: "power3.inOut",
      smoothChildTiming: false,
      delay: 1000/1000.0
    });
    logoAI.eventCallback("onComplete", () => {
      $('.logofg div').css('opacity',1);
      $('.logofg svg').css('opacity',0);
      logoBgAI.play();
    });
    logoAI.fromTo('.logofg svg g#Logo',{},{immediateRender: true,duration: 1.0},0);
    logoAI.fromTo('.logofg svg g#Logo_Text',{attr:{opacity: "1"}},{attr:{opacity: "0"}, immediateRender: true, duration:1.0},0);
    logoAI.fromTo('.logofg svg',{css:{x:"0px"}},{css:{x:translateX}, immediateRender: true},0);

    if(this.services.mobile.isHybrid()){
      setTimeout(()=>{
        (<any>window).navigator.splashscreen.hide();
        setTimeout(()=>{
          logoAI.play();
        }, 100);
      }, 100);
    }else{
      logoAI.play();
    }
  }
}
